import type { User } from './user';

export interface CreateBookingDto {
  type: BookingTypes;
  userId: string;
  externalId: string;
  time: Date;
  courseId: number;
  partnerPromo?: string;
  locale: string;
  source?: string;
}

export interface Booking {
  id: string;
  type: string;
  userId: string;
  expertId: string;
  time: Date;
  course_id: number;
}

export interface CreateBookingResponse {
  statusCode: number;
  booking?: Booking;
  message?: string;
}

export interface UpdateBookingDto {
  id: string;
  status: string;
  time: Date;
  edited: boolean | true;
}

export interface UpdateBookingTimeResponse {
  id: string;
  type: BookingTypes;
  status: BookingStatus;
  time: string;
  requestedAt: string;
  edited: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BookingResponse {
  id: string;
  course_id: string;
  type: string;
  status: string;
  time: string;
  requestedAt: string;
  edited: boolean | null;
  createdAt: string;
  updatedAt: string;
  user?: User;
  expert_id?: string;
  firstName?: string;
  lastName?: string;
}

export interface BookingDetails {
  id: string;
  user_id: string;
  type: string;
  status: string;
  time: string;
  requestedAt: string;
  edited: boolean | null;
  createdAt: string;
  updatedAt: string;
  firstName: string;
  lastName: string;
  authUserId: string;
}

export enum BookingStatus {
  NEW = 'CREATED',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  CHANGED = 'CHANGED',
}

export interface UserBookingsResponse {
  data: (Booking & { type: string })[];
}

export interface BookingType {
  bookings_id: string;
  bookings_type: BookingTypes;
  bookings_status: string;
  bookings_time: string;
  bookings_requested_at: string;
  bookings_created_at: string;
  bookings_updated_at: string;
  expert_id?: string;
  partner_id?: string;
  course_id?: string;
  booking_id: string;
}

export enum BookingTypes {
  THERAPIST_SESSION = 'therapist_session',
  ORIENTATION_CALL = 'orientation_call',
  PARTNER = 'partner',
  COURSE = 'course',
}

export enum BookingSource {
  EXPERT = 'expert',
  USER = 'user',
}

export interface MeetingToken {
  token: string;
  roomName?: string;
}

export interface UpdateBookingTimeDto {
  newTime: string;
}
